module.exports = __webpack_public_path__ + "img/eclerck_logo.8dc8741e.png";